module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAsCAMAAABBqSgLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF0+fe2uvk2dzay9rT8/Pz+vz7x9PM6PLr6urq4e7n7vXxzuHY4OLi0dHR3u7p////2n+M6AAAAQVJREFUeNp8lNsOhCAMRKcCCqLl//92iywuty7xweS0M0NtRKrnpOBSf/C+BWYKGiRmPjQI5ugVeEqnsQoUS45aoGwJBTpk6NbwYNbT0gNpDVHguYKudA6R0FqOrWgtM3UzDBVymOEV39YZevMHugqxqfeUD+MXsCba27j1nvUu1MbF+6UXidA5rmDT140XzWCn8c6wGS9G1TLeQwpOh+/6dK2APECGg+ovWYakQJMhNCiBNFXaBGqq8AI11WgTNFWxTNBUWVYCh4mkWCZc973vBivLBCtUzj4KGFcGb/1WC9DmeVfTXrVAKkSDru5vIgLF4Qmx+x4Wha/FbWdYK/yz+B8BBgC3/T8bLWvIcQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/ID.png
// module id = tfVr
// module chunks = 1